<template>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <span class="cursor-pointer flex items-center i18n-locale mr-4">
            <vs-icon color="primary" v-bind="$iconData('icon-server', 'fi-rr-database')"></vs-icon>
            <span class="hidden sm:block ml-2">{{active.name}}</span>
        </span>
        <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
            <vs-dropdown-item :disabled="server.name === active.name" class="i18n-item" v-for="server in servers" :key="server.name" @click="changeServer(server)">
                <vs-icon color="primary" v-bind="$iconData('icon-hard-drive', 'fi-rr-hdd')"></vs-icon>
                <span>{{server.name}}</span>
            </vs-dropdown-item>
        </vs-dropdown-menu>
    </vs-dropdown>
</template>

<script>
import getUseServer from "@/utils/getServer"

export default {
    name: 'server-drop-down',

    data() {
        return {
            active: {},
            servers: []
        }
    },

    methods: {
        isToken(tokenName) {
            return !!localStorage.getItem(tokenName);
        },

        async changeServer(server) {
            if (server.name !== this.active.name) {
                if (!this.isToken(server.name)) {
                    this.$ns.loginDialog({
                        title: this.$t('global.Login'),
                        accept: async (data) => {
                            const response = await this.$store.dispatch('isLogin', {data, server})

                            if (response.result) {
                                this.active = server
                                location.reload()
                            }
                        },
                    })
                } else {
                    this.active = server
                    localStorage.setItem('server', server.name)
                    location.reload()
                }
            }
        }
    },

    mounted() {
        this.servers = JSON.parse(process.env.VUE_APP_API_SERVERS) || []
        this.active = getUseServer()
    }
}
</script>
